import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgHeartFill(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M29.25 11.3388C29.25 9.13389 28.6115 7.35893 27.4915 6.06651C26.3769 4.78022 24.8708 4.07085 23.3094 3.83797C20.7682 3.45894 17.9197 4.3217 16 6.22951C14.0803 4.3217 11.2318 3.45894 8.6906 3.83797C7.12919 4.07085 5.62311 4.78022 4.50846 6.06651C3.3885 7.35893 2.75 9.1339 2.75 11.3388C2.75 15.6613 4.65079 19.0308 7.15155 21.7051C9.62728 24.3527 12.7575 26.3879 15.3201 28.049C15.7337 28.3171 16.2663 28.3171 16.6799 28.049C19.2425 26.3879 22.3727 24.3527 24.8484 21.7051C27.3492 19.0308 29.25 15.6613 29.25 11.3388Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgHeartFill);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
